// src/components/standard-page-builder.js

import React from "react"
import OneColumnContent from "../layouts/OneColumnContent"
import PbTwoColumnImageRight from "../layouts/PbTwoColumnImageRight"
import PbTwoColumnImageLeft from "../layouts/PbTwoColumnImageLeft"
import PageTestimonial from "../layouts/PageTestimonial"
import TwoHalfColumns from "../layouts/TwoHalfColumns"
import TwoThirdsOneThird from "../layouts/TwoThirdsOneThird"
import PageCallToAction from "../layouts/PageCallToAction"
import PbFullWidthImage from "../layouts/PbFullWidthImage"

const StandardPageBuilder = ({ layoutData }) => {

  const layoutType = layoutData.fieldGroupName

  /**
   * Default component
   */
  const Default = () => <div>In AllLayouts the mapping of this component is missing: {layoutType}</div>

  /**
   * Mapping the fieldGroupName(s) to our components
   */
  const layouts = {
    Page_Pagebuilder_StandardPageBuilder_PbOneColumnContent: OneColumnContent,
    Page_Pagebuilder_StandardPageBuilder_PbTwoColumnRightImage: PbTwoColumnImageRight,
    Page_Pagebuilder_StandardPageBuilder_PbTwoColumnLeftImage: PbTwoColumnImageLeft,
    Page_Pagebuilder_StandardPageBuilder_PbPageTestimonial: PageTestimonial,
    Page_Pagebuilder_StandardPageBuilder_PbTwoHalfColumns: TwoHalfColumns,
    Page_Pagebuilder_StandardPageBuilder_PbTwoThirdsOneThird: TwoThirdsOneThird,
    Page_Pagebuilder_StandardPageBuilder_PbCallToAction: PageCallToAction,
    Page_Pagebuilder_StandardPageBuilder_PbFullWidthImage: PbFullWidthImage,
    page_default: Default
  }

  /**
   * If layout type is not existing in our mapping, it shows our Default instead.
   */
  const ComponentTag = layouts[layoutType] ? layouts[layoutType] : layouts['page_default']

  return (
    <ComponentTag {...layoutData} />
  )
}

export default StandardPageBuilder